/* eslint-disable */
import BasicLayout from '@/layouts/basic-layout';

const meta = {
    auth: true,
};

const pre = 'integral-';

export default {
    path: '/integral',
    name: 'integral',
    redirect: {
        name: `${pre}order`,
    },
    meta,
    component: BasicLayout,
    children: [
        {
            path: 'carousel',
            name: `${pre}carousel`,
            meta: {
                ...meta,
                title: '轮播图管理',
            },
            component: () => import('@/pages/integral/carousel'),
        },
        {
            path: 'goods-cate',
            name: `${pre}goods-cate`,
            meta: {
                ...meta,
                title: '商品分类管理',
            },
            component: () => import('@/pages/integral/goods-cate'),
        },
        {
            path: 'goods',
            name: `${pre}goods`,
            meta: {
                ...meta,
                title: '商品管理',
            },
            component: () => import('@/pages/integral/goods'),
        },
        {
            path: 'order',
            name: `${pre}order`,
            meta: {
                ...meta,
                title: '订单管理',
            },
            component: () => import('@/pages/integral/order'),
        },
        {
            path: 'rule',
            name: `${pre}rule`,
            meta: {
                ...meta,
                title: '积分规则管理',
            },
            component: () => import('@/pages/integral/rule'),
        },
        // {
        //     path: 'data',
        //     name: `${pre}data`,
        //     meta: {
        //         ...meta,
        //         title: '数据统计',
        //     },
        //     component: () => import('@/pages/integral/data'),
        // },
        {
            path: 'get-record',
            name: `${pre}get-record`,
            meta: {
                ...meta,
                title: '积分获取记录',
            },
            component: () => import('@/pages/integral/get-record'),
        },
        {
            path: 'use-record',
            name: `${pre}use-record`,
            meta: {
                ...meta,
                title: '积分使用记录',
            },
            component: () => import('@/pages/integral/use-record'),
        },
    ],
};
